/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The InvestmentProposalRequest model module.
 * @module model/InvestmentProposalRequest
 * @version 1.0.0
 */
class InvestmentProposalRequest {
    /**
     * Constructs a new <code>InvestmentProposalRequest</code>.
     * @alias module:model/InvestmentProposalRequest
     * @param proposalContent {String} 
     */
    constructor(proposalContent) { 
        
        InvestmentProposalRequest.initialize(this, proposalContent);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, proposalContent) { 
        obj['proposal_content'] = proposalContent;
    }

    /**
     * Constructs a <code>InvestmentProposalRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/InvestmentProposalRequest} obj Optional instance to populate.
     * @return {module:model/InvestmentProposalRequest} The populated <code>InvestmentProposalRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new InvestmentProposalRequest();

            if (data.hasOwnProperty('user_id')) {
                obj['user_id'] = ApiClient.convertToType(data['user_id'], 'Number');
            }
            if (data.hasOwnProperty('proposal_content')) {
                obj['proposal_content'] = ApiClient.convertToType(data['proposal_content'], 'String');
            }
            if (data.hasOwnProperty('short_appeal_message')) {
                obj['short_appeal_message'] = ApiClient.convertToType(data['short_appeal_message'], 'String');
            }
            if (data.hasOwnProperty('proposal_date')) {
                obj['proposal_date'] = ApiClient.convertToType(data['proposal_date'], 'String');
            }
            if (data.hasOwnProperty('agent_message_template_id')) {
                obj['agent_message_template_id'] = ApiClient.convertToType(data['agent_message_template_id'], 'Number');
            }
            if (data.hasOwnProperty('replace_same_day')) {
                obj['replace_same_day'] = ApiClient.convertToType(data['replace_same_day'], 'Boolean');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>InvestmentProposalRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>InvestmentProposalRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of InvestmentProposalRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['proposal_content'] && !(typeof data['proposal_content'] === 'string' || data['proposal_content'] instanceof String)) {
            throw new Error("Expected the field `proposal_content` to be a primitive type in the JSON string but got " + data['proposal_content']);
        }
        // ensure the json data is a string
        if (data['short_appeal_message'] && !(typeof data['short_appeal_message'] === 'string' || data['short_appeal_message'] instanceof String)) {
            throw new Error("Expected the field `short_appeal_message` to be a primitive type in the JSON string but got " + data['short_appeal_message']);
        }
        // ensure the json data is a string
        if (data['proposal_date'] && !(typeof data['proposal_date'] === 'string' || data['proposal_date'] instanceof String)) {
            throw new Error("Expected the field `proposal_date` to be a primitive type in the JSON string but got " + data['proposal_date']);
        }

        return true;
    }


}

InvestmentProposalRequest.RequiredProperties = ["proposal_content"];

/**
 * @member {Number} user_id
 */
InvestmentProposalRequest.prototype['user_id'] = undefined;

/**
 * @member {String} proposal_content
 */
InvestmentProposalRequest.prototype['proposal_content'] = undefined;

/**
 * @member {String} short_appeal_message
 */
InvestmentProposalRequest.prototype['short_appeal_message'] = undefined;

/**
 * 未来日時の場合は予約送信予定日時。未指定または現在以前の場合は即時送信。
 * @member {String} proposal_date
 */
InvestmentProposalRequest.prototype['proposal_date'] = undefined;

/**
 * 本文の元にしたメッセージテンプレートの ID（テンプレート別分析用）。テンプレート未使用の場合は未指定。
 * @member {Number} agent_message_template_id
 */
InvestmentProposalRequest.prototype['agent_message_template_id'] = undefined;

/**
 * true かつ proposal_date が未来日時のとき、同一ユーザー宛てで同じ暦日（JST）に入っている送信予約を取り消してから登録する。
 * @member {Boolean} replace_same_day
 * @default false
 */
InvestmentProposalRequest.prototype['replace_same_day'] = false;






export default InvestmentProposalRequest;

